module.exports = __webpack_public_path__ + "static/media/SeroBlue.54181b80.jpg";